export default __webpack_public_path__ + "assets/images/f588ca580ec5a541f61481068d8f74d5.jpg";